export default "__VITE_ASSET__CSU8SX2x__"